import projectService from "@/service/project-service"

export default {
  screensRef(projectId) {
    return projectService.projectDataRef(projectId).child("screens")
  },

  async addOneScreen(projectId) {
    // TODO: use transaction
    const snapshot = await this.screensRef(projectId).once("value")
    const screenNumber = snapshot.val()
    await this.screensRef(projectId).set(screenNumber + 1)
    return screenNumber + 1
  },

  async removeOneScreen(projectId) {
    const snapshot = await this.screensRef(projectId).once("value")
    const screenNumber = snapshot.val()
    await this.screensRef(projectId).set(screenNumber - 1)
    return screenNumber - 1
  },

  onCountChanged(projectId, callback, errorCallback) {
    this.screensRef(projectId).on(
      "value",
      snapshot => {
        callback(snapshot.val() || 0)
      },
      errorCallback
    )
  },

  offCountChanged(projectId) {
    this.screensRef(projectId).off()
  }
}
